import type { ReactNode } from "react";
import classNames from "classnames";

export interface ActionContentProps {
  children: ReactNode;
  className?: string;
  tooltipContent?: string;
}

export const ActionContent = ({
  tooltipContent,
  className,
  children,
}: ActionContentProps) => (
  <div
    className={classNames("flex items-center justify-center", className, {
      "cursor-pointer": tooltipContent,
    })}
  >
    {children}
  </div>
);
